module.exports = __webpack_public_path__ + "img/19.09f5e73f.jpg";